import React from 'react';
import { useSelector } from 'react-redux';
import { AssignedUser } from '../../components/assigned-user';
import style from './assigned-to.module.less';

import Global from '../../../../../store/global-selectors';

const AssignedUserColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { assignedToUserGuid } = fulfillmentPlanSet ?? {};

  return <AssignedUser userId={assignedToUserGuid} />;
};

export default {
  id: 'assigned-to',
  messageDescriptorKey: 'assignedTo',
  width: 150,
  nonsortable: true,
  render: ({ fulfillmentPlanSetId }) => <AssignedUserColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
  className: style['assigned-to-column'],
};
